/* eslint formatjs/no-literal-string-in-jsx: off -- will be deleted by the end of 2023 when we end our partnership with Ava */

import styled from "styled-components"
import { Button } from "../atoms/buttons/Button"
// @ts-ignore
import colors from "../../../css/colors.scss"
import React, { FC } from "react"
import { useSelector } from "react-redux"
import { getAvaCheckoutLandingPageUrl } from "../../../reducers/ava"

const StyledAvaButton = styled(Button)`
  &:hover {
    background-color: ${colors.fairPink50Opacity};
  }
`
type AvaCheckoutButtonProps = {
  ButtonComponent?: FC
}

const AvaCheckoutButton: FC<AvaCheckoutButtonProps> = ({ ButtonComponent = StyledAvaButton }) => {
  const avaCheckoutLandingPageUrl = useSelector(getAvaCheckoutLandingPageUrl)

  async function goToAva() {
    window.open(avaCheckoutLandingPageUrl)
  }

  return (
    <ButtonComponent
      disabledBackgroundColor={"white"}
      disabledColor={"black-10"}
      enabled={avaCheckoutLandingPageUrl != null}
      onClick={goToAva}
    >
      Ava website
    </ButtonComponent>
  )
}

export { AvaCheckoutButton }
